import {fabric} from "fabric";
import TextService from "./js/insertText";
import MaterialService from "./js/materialService";
import MaskService from "./js/maskService";
import CustomListeners from "./js/customListeners";
import initPanZoom from "./js/panAndZoom";
import MeasurementUI from "./js/measurementUI";
import Delegate from "./js/delegate";
import Swal from 'sweetalert2';
import {confirmClose} from "./js/actions";
import LowResChecker from "./js/lowResChecker";

export default function getImageEditor () {
    return window.imageEditor;
}

export const functions = {
    updateMask: () => window.imageEditor.maskService.updateMask(),
    updateBackground: () => window.imageEditor.updateBackground(),
    insertText: () => window.imageEditor.textService.insertText(),
    setMaterial: (id) => window.imageEditor.materialService.setMaterial(id, true),
};

export class ImageEditor {
    canvasWindow;

    store;
    materialService;
    maskService;
    textService;
    customListeners;
    measurementUI;
    lowResChecker;

    processingFinishedDelegate;

    constructor({store, canvasWindow}) {
        let app = this;
        window.imageEditor = app;
        fabric.Canvas.prototype.getAbsoluteCoords = function(object, params = {}) {
            const { center = false } = params;

            let zoom = this.getZoom();
            let left = object.left;
            let top = object.top;
            if (object.originX === 'center') {
                left -= object.width/2;
            }
            if (object.originY === 'center') {
                top -= object.height/2;
            }

            left = (left * zoom) + this.viewportTransform[4];
            top = (top * zoom) + this.viewportTransform[5];

            return { left: left, top: top };
        };

        this.store = store;
        this.canvasWindow = canvasWindow;

        this.customListeners = new CustomListeners(store);
        this.materialService = new MaterialService(store, this);
        this.maskService = new MaskService(store, this);
        this.textService = new TextService(store, this);
        this.measurementUI = new MeasurementUI(store);
        this.lowResChecker = new LowResChecker(store);
        this.init_changeHistory();
        initPanZoom({ canvas: this.store.canvas, imageEditor: this});

        this.store.onDimensionsChanged(_.debounce(function() {
            app.onResize();
        }, 250));

        let defaultValues = {
            borderColor: '#222',
            cornerColor: '#222',
            cornerStrokeColor: '#222',
            transparentCorners: true,
            cornerStyle: 'circle',
            hoverCursor: 'default',
            perPixelTargetFind: false,
        };

        fabric.Object.prototype.set({...defaultValues, perPixelTargetFind: true});
        fabric.IText.prototype.set(defaultValues);

        this.processingFinishedDelegate = new Delegate();

        app.onResize();
        this.resetViewport();

        window.addEventListener('resize', _.debounce(function() {
            app.onResize();
        }, 250));
    }

    refresh() {
        this.updateBackground();
        this.maskService.updateMask();
    }

    updateBackground () {
        let canvas = this.store.canvas;

        canvas.backgroundColor = this.store.bg_color;

        canvas.requestRenderAll();
    }

    oldWidth;
    oldHeight;
    onResize() {
        let canvas = this.store.canvas;

        canvas.getElement().parentNode.style.width = "0px";
        canvas.getElement().parentNode.style.height = "0px";

        let newWidth = this.canvasWindow.clientWidth;
        let newHeight = this.canvasWindow.clientHeight;

        this.changeCanvasSize({canvas, newWidth, newHeight, initialWidth: this.oldWidth, initialHeight: this.oldHeight})
        canvas.zoomToMask({store: this.store, zoom: 0.6});

        this.oldWidth = newWidth;
        this.oldHeight = newHeight;

        this.refresh();
    }

    resetViewport() {
        let canvas = this.store.canvas;
        canvas.setViewportTransform([ 1, 0, 0, 1, 0, 0 ]);

        let point = new fabric.Point(canvas.width / 2, canvas.height / 2);
        canvas.zoomToPoint(point, Math.min(this.canvasWindow.clientHeight, this.canvasWindow.clientWidth) * 0.00095);
    }

    changeCanvasSize({canvas, newWidth, newHeight, silent = false} = {}) {
        canvas.setWidth(newWidth);
        canvas.setHeight(newHeight);

        if (!silent) {
            canvas.fire('canvas:resize');
        }
    }

    onProcessingFinished() {
        this.processingFinishedDelegate.invoke();
    }
}

export function isMobileDevice() {
    if (window.innerWidth < 992) {
        return true;
    }

    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
